import { keyBy } from 'lodash';

const getGroupSyncDiffs = (existingRows, newGroupList) => {
  const rows = Array.isArray(existingRows) ? existingRows : [];
  const remoteGroups = Array.isArray(newGroupList) ? newGroupList : [];

  const rowsById = keyBy(rows, (row) => `${row.id}`);
  const remoteById = keyBy(remoteGroups, (group) => `${group.id}`);
  const findRemote = (id) => remoteById[`${id}`];

  return rows
    .flatMap((row) => {
      const retDiffs = [];
      const groupId = `${row.id}`;
      const latestGroupSynced = findRemote(groupId);

      if (latestGroupSynced && latestGroupSynced.name !== row.group) {
        retDiffs.push({
          id: groupId,
          type: 'warning',
          label: 'Change Name',
          message: `"${row.group}" changed to "${latestGroupSynced.name}"`
        });
      }

      if (latestGroupSynced && typeof row.parent !== 'undefined') {
        const parentId = `${row.parent}`;
        const parentRow = rowsById[parentId];

        if (!findRemote(parentId)) {
          retDiffs.push({
            id: groupId,
            type: 'danger',
            label: 'Missing Parent Group',
            message: parentRow
              ? `"${latestGroupSynced.name}" was previously mapped under "${parentRow.group}"`
              : `"${latestGroupSynced.name}" was previously mapped under removed group`
          });
        }
      }

      if (!latestGroupSynced) {
        retDiffs.push({
          id: groupId,
          type: 'danger',
          label: 'Missing Group',
          message: `"${row.group}" removed`
        });
      }

      return retDiffs;
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};

export default {
  getGroupSyncDiffs
};
